import loadable, { LoadableLibrary } from '@loadable/component';

const ServicePage = loadable(() => import('../../client/components/ServicePage/Home'));
const Homepage = loadable(() => import('../../client/components/Homepage/index'));
const LandingPageRedirect = loadable(() => import('../../client/components/Redirects/LandingPageRedirect'));
const ListingPage = loadable(() => import('../../client/components/ListingPage/index'));
const ProductDetailPage = loadable(() => import('../../client/components/ProductDetailPage/index'));

export interface RouteInterface {
    path: string;
    code: number;
    exact: boolean;
    component: LoadableLibrary<any>;
    slug?: string;
}

const routes: Array<RouteInterface> = [
    {
        path: '/',
        code: 200,
        exact: true,
        component: Homepage,
        slug: '',
    },
    {
        path: '/index',
        code: 200,
        exact: true,
        component: Homepage,
    },
    {
        path: '/index/index',
        code: 200,
        exact: true,
        component: Homepage,
    },
    {
        path: '/service-page',
        code: 200,
        exact: true,
        component: ServicePage,
        slug: '',
    },
    {
        path: '/*.html',
        code: 200,
        exact: true,
        component: ProductDetailPage,
        slug: '',
    },
    {
        path: '/landing/:listingPageKey',
        code: 200,
        exact: false,
        component: LandingPageRedirect,
        slug: '',
    },
    {
        path: '/:listingPageKey',
        exact: false,
        code: 200,
        component: ListingPage,
    },
];

export default routes;
